import state from "./state";
import mutations from "./mutations";

const sidebarMenu = {
  namespaced: true,
  state,
  mutations,
};

export default sidebarMenu;
